"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _breakpoints = _interopRequireDefault(require("./breakpoints"));
var _constants = require("./constants");
const typography = {
  fontFamily: _constants.font.fontFamily,
  fontWeightLight: _constants.font.fontWeightLight,
  fontWeightRegular: _constants.font.fontWeightRegular,
  fontWeightMedium: _constants.font.fontWeightMedium,
  fontWeightBold: _constants.font.fontWeightBold,
  htmlFontSize: _constants.font.htmlFontSize,
  hero: {
    fontSize: '3rem',
    fontWeight: 'bold',
    lineHeight: 1.4,
    [_breakpoints.default.up('md')]: {
      fontSize: '5rem'
    }
  },
  banner: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    lineHeight: 1.4,
    [_breakpoints.default.up('md')]: {
      fontSize: '3rem'
    }
  },
  h1: {
    fontSize: '3rem',
    fontWeight: 'bold',
    lineHeight: 1.3,
    [_breakpoints.default.up('md')]: {
      fontSize: '9rem',
      lineHeight: 1.15
    }
  },
  h2: {
    fontSize: '3rem',
    fontWeight: 'bold',
    lineHeight: 1.3,
    [_breakpoints.default.up('md')]: {
      fontSize: '5rem',
      lineHeight: 1.2
    }
  },
  h3: {
    fontSize: '3rem',
    fontWeight: 'bold',
    lineHeight: 1.3,
    [_breakpoints.default.up('md')]: {
      fontSize: '4rem',
      lineHeight: 1.2
    }
  },
  h4: {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    lineHeight: 1.4,
    [_breakpoints.default.up('md')]: {
      fontSize: '3rem',
      lineHeight: 1.3
    }
  },
  h5: {
    fontSize: '2rem',
    fontWeight: 'bold',
    lineHeight: 1.5,
    [_breakpoints.default.up('md')]: {
      fontSize: '2.5rem',
      lineHeight: 1.4
    }
  },
  h6: {
    fontSize: '1.7rem',
    fontWeight: 'bold',
    lineHeight: 1.6,
    [_breakpoints.default.up('md')]: {
      fontSize: '2rem',
      lineHeight: 1.5
    }
  },
  subtitle1: {
    fontSize: '1.7rem',
    lineHeight: 1.6
  },
  subtitle2: {
    fontSize: '1.8rem',
    lineHeight: 1.6,
    fontWeight: 'normal'
  },
  body1: {
    fontSize: '1.4rem',
    lineHeight: 1.5,
    fontWeight: 'normal'
  },
  body2: {
    fontSize: '1.6rem',
    lineHeight: 1.5
  },
  button: {
    fontSize: '1.4rem',
    lineHeight: 1.75,
    fontWeight: 'bold'
  },
  caption: {
    fontSize: '1.2rem',
    lineHeight: 1.5
  },
  overline: {
    fontSize: '1rem',
    lineHeight: 1.5,
    textTransform: 'none'
  }
};
var _default = exports.default = typography;
